import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-enable",
  "use": "icon-enable-usage",
  "viewBox": "0 0 63 63",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 63 63\" id=\"icon-enable\"><path d=\"M54.74,5.72,63,14.44Q41.46,35.64,19.43,57.28L0,38.18,8.8,29l11.13,11Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol